import React, {useEffect, useState, useCallback} from 'react';
import {withRouter, useParams, Link} from 'react-router-dom';
import {useDispatch} from "react-redux";
import {Menu} from '../../utils/menu/Menu';
import {
  permissionEditAction,
  permissionGetAction
} from '../../actions/rolesAction';
import {formatErrors} from '../../constants';
import {toast} from 'react-toastify';
import {InputProfile} from "../../utils/input/InputProfile";
import {InputCheckbox} from "../../utils/checkbox/InputCheckbox";

function Permission(props) {
    const dispatch = useDispatch();
    const {id} = useParams();
    const {history} = props;
    const [item, setItem] = useState(null);
    const [errors, setErrors] = useState({});
    const [form, setForm] = useState(null);
    const [loading, setLoading] = useState(false);
  
    const getPermission = useCallback((id) => {
      dispatch(permissionGetAction(id)).then((data) => {
        setItem(data);
        const permission = data.permission.split(',').map(i => i.trim());
        setForm({
          id: data.id,
          name: data.name,
          module: data.module,
          route_path: data.route_path,
          permission: data.permission,
          read: permission.includes('read'),
          edit: permission.includes('edit'),
          delete: permission.includes('delete')
        });
      }).catch(err => {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    }, [dispatch]);
  
    const handleChangeForm = (e) => {
      const {name, value} = e.target;
      setForm(prev => ({...prev, [name]: value}));
      setErrors(prev => ({...prev, [name]: value.trim() === ''}));
    };

    const handleChangeCheckbox = (name) => {
      setForm(prev => ({...prev, [name]: !prev[name]}));
      setErrors(prev => ({...prev, [name]: !prev[name] ? '' : true}));
    };

  
    const handleSubmit = (e) => {
      e.preventDefault();
      if (loading) return;
  
      const errs = {};
      if (!form.name) errs.name = true;
  
      setErrors(errs);
      if (Object.keys(errs).length > 0) return;
  
      setLoading(true);
      dispatch(permissionEditAction({...form, permission: [form.read ? 'read' : '', form.edit ? 'edit' : '', form.delete ? 'delete' : ''].filter(Boolean).join(',')})).then((data) => {
        setLoading(false);
        toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
        if (!form.id) {
          history.push('/permissions');
        }
      }).catch((e) => {
        setLoading(false);
        toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    };

    useEffect(() => {
      if (id && id !== '0') {
        getPermission(id);
      } else {
        setForm({ id: 0, name: '' });
      }
    }, [id, getPermission]);

  return <div className="content">
    <Menu />

    <header className="header header--nav">
      <Link to={'/permissions'} className="header__link">Разрешения</Link>
    </header>

    {form && <div className="profile">
      <form className="profile__wrapper" noValidate onSubmit={handleSubmit}>
        <span className="profile__heading">Разрешение</span>
        {item && <h4 className="profile__name">{item.name}</h4>}

        <div className="profile__inner profile__inner--group">
          <div className="profile__wrap">
            <InputProfile type="text"
                          title="Название"
                          name="name"
                          placeholder="Введите название"
                          value={form.name}
                          error={errors.name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <InputProfile type="text"
                          title="Модуль (для группировки)"
                          name="module"
                          placeholder="Введите название модуля"
                          value={form.module}
                          error={errors.module || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <InputProfile type="text"
                          title="Путь"
                          name="route_path"
                          placeholder="Введите путь"
                          value={form.route_path}
                          error={errors.route_path || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <div style={{textAlign: 'left', marginTop: 20}}>
              <p className="help">Разрешения</p>
              <div>
                <InputCheckbox title="Чтение" name="read" checked={form.read} onChange={() => handleChangeCheckbox('read')}/>
                <InputCheckbox title="Редактировать" name="edit" checked={form.edit} onChange={() => handleChangeCheckbox('edit')}/>
                <InputCheckbox title="Удалять" name="delete" checked={form.delete} onChange={() => handleChangeCheckbox('delete')}/>
              </div>
            </div>
          </div>
        </div>

        <button className="profile__btn btn">Сохранить</button>
      </form>
    </div>}
  </div>;
};

export default withRouter(Permission);
